declare namespace $ {

	type $bog_ui_sidebar_item__Icon_bog_ui_app_1 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Overview_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_3 = $mol_type_enforce<
		ReturnType< $bog_ui_app['overview_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_4 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_overview'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_5 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Badge_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_6 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_7 = $mol_type_enforce<
		ReturnType< $bog_ui_app['badge_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_8 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_badge'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_9 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Empty_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_11 = $mol_type_enforce<
		ReturnType< $bog_ui_app['empty_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_12 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_empty'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_13 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Skeleton_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_14 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_15 = $mol_type_enforce<
		ReturnType< $bog_ui_app['skeleton_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_16 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_skeleton'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_17 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Breadcrumb_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_19 = $mol_type_enforce<
		ReturnType< $bog_ui_app['breadcrumb_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_20 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_breadcrumb'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_21 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Sidebar_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_22 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_23 = $mol_type_enforce<
		ReturnType< $bog_ui_app['sidebar_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_24 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_sidebar'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_25 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Sheet_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_26 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_27 = $mol_type_enforce<
		ReturnType< $bog_ui_app['sheet_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_28 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_sheet'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_29 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Toast_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_30 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_31 = $mol_type_enforce<
		ReturnType< $bog_ui_app['toast_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_32 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_toast'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_33 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Command_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_34 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_35 = $mol_type_enforce<
		ReturnType< $bog_ui_app['command_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_36 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_command'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_37 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Table_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_38 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_39 = $mol_type_enforce<
		ReturnType< $bog_ui_app['table_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_40 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_table'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_41 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Divider_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_42 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_43 = $mol_type_enforce<
		ReturnType< $bog_ui_app['divider_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_44 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_divider'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_45 = $mol_type_enforce<
		ReturnType< $bog_ui_app['Tooltip_icon'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_46 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__active_bog_ui_app_47 = $mol_type_enforce<
		ReturnType< $bog_ui_app['tooltip_active'] >
		,
		ReturnType< $bog_ui_sidebar_item['active'] >
	>
	type $bog_ui_sidebar_item__click_bog_ui_app_48 = $mol_type_enforce<
		ReturnType< $bog_ui_app['nav_tooltip'] >
		,
		ReturnType< $bog_ui_sidebar_item['click'] >
	>
	type $bog_ui_sidebar__mode_bog_ui_app_49 = $mol_type_enforce<
		ReturnType< $bog_ui_app['sidebar_mode'] >
		,
		ReturnType< $bog_ui_sidebar['mode'] >
	>
	type $bog_ui_sidebar__items_bog_ui_app_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_ui_sidebar['items'] >
	>
	type $mol_view__sub_bog_ui_app_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_bog_ui_app_52 = $mol_type_enforce<
		ReturnType< $bog_ui_app['page_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_ui_app_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_ui_app_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $bog_ui_command__showed_bog_ui_app_55 = $mol_type_enforce<
		ReturnType< $bog_ui_app['command_showed'] >
		,
		ReturnType< $bog_ui_command['showed'] >
	>
	export class $bog_ui_app extends $mol_book2 {
		Theme( ): $mol_theme_auto
		Tip( ): $bog_ui_tooltip
		global_keydown( next?: any ): any
		sidebar_mode( next?: string ): string
		Overview_icon( ): $mol_icon_view_grid
		overview_active( ): boolean
		nav_overview( next?: any ): any
		Overview_nav( ): $bog_ui_sidebar_item
		Badge_icon( ): $mol_icon_tag
		badge_active( ): boolean
		nav_badge( next?: any ): any
		Badge_nav( ): $bog_ui_sidebar_item
		Empty_icon( ): $mol_icon_file
		empty_active( ): boolean
		nav_empty( next?: any ): any
		Empty_nav( ): $bog_ui_sidebar_item
		Skeleton_icon( ): $mol_icon_rectangle
		skeleton_active( ): boolean
		nav_skeleton( next?: any ): any
		Skeleton_nav( ): $bog_ui_sidebar_item
		Breadcrumb_icon( ): $mol_icon_navigation
		breadcrumb_active( ): boolean
		nav_breadcrumb( next?: any ): any
		Breadcrumb_nav( ): $bog_ui_sidebar_item
		Sidebar_icon( ): $mol_icon_dock_left
		sidebar_active( ): boolean
		nav_sidebar( next?: any ): any
		Sidebar_nav( ): $bog_ui_sidebar_item
		Sheet_icon( ): $mol_icon_card
		sheet_active( ): boolean
		nav_sheet( next?: any ): any
		Sheet_nav( ): $bog_ui_sidebar_item
		Toast_icon( ): $mol_icon_bell
		toast_active( ): boolean
		nav_toast( next?: any ): any
		Toast_nav( ): $bog_ui_sidebar_item
		Command_icon( ): $mol_icon_console
		command_active( ): boolean
		nav_command( next?: any ): any
		Command_nav( ): $bog_ui_sidebar_item
		Table_icon( ): $mol_icon_table
		table_active( ): boolean
		nav_table( next?: any ): any
		Table_nav( ): $bog_ui_sidebar_item
		Divider_icon( ): $mol_icon_minus
		divider_active( ): boolean
		nav_divider( next?: any ): any
		Divider_nav( ): $bog_ui_sidebar_item
		Tooltip_icon( ): $mol_icon_message
		tooltip_active( ): boolean
		nav_tooltip( next?: any ): any
		Tooltip_nav( ): $bog_ui_sidebar_item
		Nav( ): $bog_ui_sidebar
		page_title( ): string
		Theme_toggle( ): $mol_lights_toggle
		page_text( ): string
		Page_body( ): $mol_view
		Content_page( ): $mol_page
		plugins( ): readonly(any)[]
		event( ): ({ 
			keydown( next?: ReturnType< $bog_ui_app['global_keydown'] > ): ReturnType< $bog_ui_app['global_keydown'] >,
		})  & ReturnType< $mol_book2['event'] >
		command_showed( next?: boolean ): boolean
		Command( ): $bog_ui_command
		Badge_page( ): $bog_ui_app_badge
		Empty_page( ): $bog_ui_app_empty
		Skeleton_page( ): $bog_ui_app_skeleton
		Breadcrumb_page( ): $bog_ui_app_breadcrumb
		Sidebar_page( ): $bog_ui_app_sidebar
		Sheet_page( ): $bog_ui_app_sheet
		Toast_page( ): $bog_ui_app_toast
		Command_page( ): $bog_ui_app_command
		Table_page( ): $bog_ui_app_table
		Overview_page( ): $bog_ui_app_overview
		Divider_page( ): $bog_ui_app_divider
		Tooltip_page( ): $bog_ui_app_tooltip
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map